/**
 * @generated SignedSource<<f9b695dcc2b79280b44886e95a186295>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PriceDisplay_displayPrice$data = {
  readonly textType: string | null;
  readonly " $fragmentType": "PriceDisplay_displayPrice";
};
export type PriceDisplay_displayPrice$key = {
  readonly " $data"?: PriceDisplay_displayPrice$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplay_displayPrice">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PriceDisplay_displayPrice",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textType",
      "storageKey": null
    }
  ],
  "type": "ItemDisplayPriceType",
  "abstractKey": null
};

(node as any).hash = "3a788ccf766b668ef235387402ca6637";

export default node;
